//Models
PJQ.models.invoicing.ReceivableInvoice = PJQ.models.invoicing.Invoice.extend({
    endpoint: function () {
        let arr = [];
        if (this.isNew()) {
            arr.push({
                endpoint: 'projects',
                value: this.get('projectId')
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([...arr, {
            endpoint: 'receivableinvoices',
            value: this.id
        }]);
    },
    parse: function (model) {
        if (!model)
            return model;

        this.lineItems = new PJQ.collections.invoicing.ReceivableInvoiceLineItems(model.lineItems);
        this.attachments = new PJQ.collections.invoicing.ReceivableInvoiceAttachments(model.attachments);
        this.payments = new PJQ.collections.invoicing.ReceivableInvoicePayments(model.payments);

        if (model.client) {
            if (model.client instanceof PJQ.models.BaseModel) {
                this.client = model.client;
            } else {
                this.client = new PJQ.models.contacts.Contact(model.client);
            }
        }

        return model;
    },
    syncERP: function(callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/syncerp',
            isAPIv2: true,
        }).post().done(_.bind(function (res) {
            if(res && _.size(res.externalId) > 0){
                this.set('externalObject', res);
            }
            if(typeof callback === 'function'){
                callback(res);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            if(typeof callback === 'function'){
                callback(null);
            }
        }, this));
    },
    unlinkERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/unlinkerp',
            isAPIv2: true,
        }).post().done(_.bind(function () {
            this.set('externalObject', null);
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(_.bind(function (xhr) {
            if (typeof callback === 'function') {
                let err;
                if (xhr.responseJSON != null) {
                    err = xhr.responseJSON.type;
                } else {
                    err = null;
                }
                callback(false, err);
            }
        }, this));
    },
    makeERPUrl: function(integration){
        let externalId = this.externalId();
        if(_.size(externalId) === 0){
            return '';
        }

        switch(integration.get('name')){
            case PJQ.constants.integrations.providers.QBO.name:
                return 'https://app.sandbox.qbo.intuit.com/app/invoice?txnId=' + externalId;
            default:
                return '';
        }
    },
    getAutofillAmounts: function(callback) {
        let fnCallback = _.bind(function () {
            if (typeof callback === 'function') {
                callback(this.autofillLineItems);
            }
        }, this)
        if (this.autofillLineItems != null) {
            fnCallback();
        } else {
            new PJQ.ajax.Request({
                endpoint: this.endpoint() + '/lineitems/autofill',
                isAPIv2: true
            }).get().done(_.bind(function (response) {
                this.autofillLineItems = new PJQ.collections.invoicing.InvoiceLineItems(response);
                fnCallback();
            }, this)).fail(_.bind(function () {
                fnCallback();
            }, this));
        }
    },
    share: function (data, callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/email',
            isAPIv2: true,
            data: {
                subject: data != null ? data.subject : null,
                body: data != null ? data.body : null,
                toEmails: data != null ? data.toEmails : null,
                ccEmails: data != null ? data.ccEmails : null,
            }
        }).post().done(_.bind(function (response) {
            callback();
        }, this)).fail(_.bind(function (xhr, err, result) {
            //todo: error
        }, this));
    }
});

PJQ.models.invoicing.ReceivableInvoiceHistoryItem = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    actionNames: {
        'status': 'Status Changed',
        'email': 'Email Sent'
    },
    getActionName: function () {
        return this.actionNames[this.get('action')] ?? this.get('action');
    },
    getDescription: function () {
        switch (this.get('action')) {
            case 'status':
                let fromStatus = this.get('data').from,
                    toStatus = this.get('data').to;
                if (fromStatus == null || toStatus == null) {
                    return '';
                }

                return '' + PJQ.constants.invoicing.receivableInvoiceStatusNames[fromStatus] + '<i class="fal fa-arrow-right ml-1 mr-1 fs-14"></i>' + PJQ.constants.invoicing.receivableInvoiceStatusNames[toStatus];
            case 'email':
                let to = this.get('data').to;
                if (_.size(to) === 0) {
                    return '';
                }

                return 'To: ' + to.join(', ');
            default:
                return '';
        }
    }
});

PJQ.models.invoicing.ReceivableInvoiceLineItem = PJQ.models.invoicing.InvoiceLineItem.extend();

PJQ.models.invoicing.ReceivableInvoiceAttachment = PJQ.models.files.File.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

PJQ.models.invoicing.ReceivableInvoiceCustomField = PJQ.models.customFields.CustomField.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'receivableinvoices'
            },
            {
                endpoint: 'customfields',
                value: this.get('id')
            }
        ]);
    }
});

PJQ.models.invoicing.ReceivableInvoiceSettings = PJQ.models.budget.Settings.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'receivableinvoices'
            },
            {
                endpoint: 'settings'
            }
        ]);
    }
});

PJQ.models.invoicing.ReceivableInvoiceUserSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'receivableinvoices'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'user'
            }
        ]);
    },
    getSettings: function (view) {
        return _.find(this.attributes.viewSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));
    }
});

PJQ.models.invoicing.ReceivableInvoiceFieldSetting = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'fields',
                value: this.id ? this.id : 'receivableinvoices'
            }
        ]);
    }
});

PJQ.models.invoicing.ReceivableInvoicePayment = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    endpoint: function () {
        let arr = [];
        if (this.isNew()) {
            arr.push({
                endpoint: 'projects',
                value: this.get('projectId')
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([...arr, {
            endpoint: 'receivableinvoicepayments',
            value: this.id
        }]);
    },
    parse: function (model) {
        if (!model)
            return model;

        this.attachments = new PJQ.collections.invoicing.ReceivableInvoiceAttachments(model.attachments);

        if (model.client) {
            if (model.client instanceof PJQ.models.BaseModel) {
                this.client = model.client;
            } else {
                this.client = new PJQ.models.contacts.Contact(model.client);
            }
        } else {
            this.client = null;
        }

        return model;
    },
    beforeSave: function () {
        this.set({
            attachments: this.attachments.toJSON()
        });
    },
    syncERP: function(callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/syncerp',
            isAPIv2: true,
        }).post().done(_.bind(function (res) {
            if(res && _.size(res.externalId) > 0){
                this.set('externalObject', res);
            }
            if(typeof callback === 'function'){
                callback(res);
            }
        }, this)).fail(_.bind(function (xhr, err, result) {
            if(typeof callback === 'function'){
                callback(null);
            }
        }, this));
    },
    unlinkERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/unlinkerp',
            isAPIv2: true,
        }).post().done(_.bind(function () {
            this.set('externalObject', null);
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(_.bind(function (xhr) {
            if (typeof callback === 'function') {
                let err;
                if (xhr.responseJSON != null) {
                    err = xhr.responseJSON.type;
                } else {
                    err = null;
                }
                callback(false, err);
            }
        }, this));
    }
});

PJQ.models.invoicing.ReceivableInvoicePaymentAttachment = PJQ.models.files.File.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

//Collections
PJQ.collections.invoicing.ReceivableInvoices = PJQ.collections.invoicing.Invoices.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.ReceivableInvoice,
    endpoint: function () {
        let params = [];
        if (this.options.costCodeId && this.options.costTypeId) {
            params.push({
                parameter: 'costCodeId',
                value: this.options.costCodeId
            }, {
                parameter: 'costTypeId',
                value: this.options.costTypeId
            });
        }

        if (this.options.primeContract != null) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'receivableinvoices',
                    value: this.options.primeContract.id
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.get('projectId')
                },
                {
                    endpoint: 'receivableinvoices'
                }
            ], params);
        }
    },
    getTotalAmountsByStatus: function () {
        let result = {};
        result[PJQ.constants.invoicing.receivableInvoiceStatus.DRAFT] = 0;
        result[PJQ.constants.invoicing.receivableInvoiceStatus.REVIEWING] = 0;
        result[PJQ.constants.invoicing.receivableInvoiceStatus.APPROVED] = 0;
        result[PJQ.constants.invoicing.receivableInvoiceStatus.COMPLETE] = 0;
        result[PJQ.constants.invoicing.receivableInvoiceStatus.REVISE] = 0;
        _.each(this.models, function (invoice) {
            result[invoice.get('statusId')] += invoice.get('amount');
        });
        return result;
    },
    getPayments: function(){
        let result = [];
        _.each(this.models, function(invoice){
            result.push(...invoice.payments.models);
        })
        return result;
    }
});

PJQ.collections.invoicing.ReceivableInvoiceHistory = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.ReceivableInvoiceHistoryItem,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'receivableinvoices',
                value: this.options.invoiceId
            },
            {
                endpoint: 'history'
            }
        ]);
    }
});

PJQ.collections.invoicing.ReceivableInvoiceLineItems = PJQ.collections.invoicing.InvoiceLineItems.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.ReceivableInvoiceLineItem
});

PJQ.collections.invoicing.ReceivableInvoiceAttachments = PJQ.collections.files.Files.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.ReceivableInvoiceAttachment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'receivableinvoices',
                value: this.options.invoiceId
            },
            {
                endpoint: 'attachments'
            }
        ]);
    }
});

PJQ.collections.invoicing.ReceivableInvoiceCustomFields = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.ReceivableInvoiceCustomField,
    endpoint: function () {
        let arr = [];
        if (this.options.projectId > 0) {
            arr.push({
                endpoint: 'projects',
                value: this.options.projectId
            });
        }
        arr.push(...[
            {
                endpoint: 'receivableinvoices'
            },
            {
                endpoint: 'customfields'
            }
        ]);
        return PJQ.helpers.urlHelpers.generateEndpoint(arr);
    }
});

PJQ.collections.invoicing.ReceivableInvoiceCustomFieldChoices = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.ReceivableInvoiceCustomFieldChoice
});

PJQ.collections.invoicing.ReceivableInvoiceFieldSettings = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.ReceivableInvoiceFieldSetting,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'fields',
                value: 'receivableinvoices'
            }
        ]);
    }
});

PJQ.collections.invoicing.ReceivableInvoicePayments = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.ReceivableInvoicePayment,
    endpoint: function () {
        if (this.options.invoiceId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'receivableinvoices',
                    value: this.options.invoiceId
                },
                {
                    endpoint: 'payments'
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.get('projectId')
                },
                {
                    endpoint: 'receivableinvoicepayments'
                }
            ]);
        }
    },
});

PJQ.collections.invoicing.ReceivableInvoicePaymentAttachments = PJQ.collections.files.Files.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.invoicing.ReceivableInvoicePaymentAttachment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'receivableinvoicepayments',
                value: this.options.paymentId
            },
            {
                endpoint: 'attachments'
            }
        ]);
    }
});